import { reducedStream, reducer } from '@ardoq/rxbeach';
import { setStateProperty, updateState } from '@ardoq/common-helpers';
import {
  historicChatLoaded,
  initializeNewChat,
  openFullscreenChatAndSend,
  sendMessageWithHistory,
} from '../actions';
import {
  closeGiveContext,
  deselectDocument,
  documentUploadFailed,
  documentUploadStarted,
  documentUploadSucceeded,
  loadOrgDocuments,
  openGiveContext,
  orgDocumentsLoaded,
  orgDocumentsLoadFailed,
  removeSelectedDocument,
  selectDocument,
  setDocumentSearchTerm,
  setWebSearchEnabled,
  showOrgDocumentsStep,
} from './assistantDocumentsActions';
import {
  assistantDocumentsOperations,
  defaultAssistantDocumentsState,
} from './assistantDocumentsOperations';

export type { AssistantDocumentsState } from './assistantDocumentsOperations';

export const assistantDocuments$ = reducedStream(
  'assistantDocuments',
  defaultAssistantDocumentsState,
  [
    reducer(
      openGiveContext,
      assistantDocumentsOperations.handleOpenGiveContext
    ),
    reducer(
      closeGiveContext,
      assistantDocumentsOperations.handleCloseGiveContext
    ),
    reducer(
      showOrgDocumentsStep,
      assistantDocumentsOperations.handleShowOrgDocumentsStep
    ),
    reducer(
      loadOrgDocuments,
      updateState({ orgDocuments: { status: 'loading' } })
    ),
    reducer(
      orgDocumentsLoaded,
      assistantDocumentsOperations.handleOrgDocumentsLoaded
    ),
    reducer(
      orgDocumentsLoadFailed,
      updateState({ orgDocuments: { status: 'error' } })
    ),
    reducer(selectDocument, assistantDocumentsOperations.handleSelectDocument),
    reducer(
      deselectDocument,
      assistantDocumentsOperations.handleDeselectDocument
    ),
    reducer(
      removeSelectedDocument,
      assistantDocumentsOperations.handleRemoveSelectedDocument
    ),
    reducer(setDocumentSearchTerm, setStateProperty('documentSearchTerm')),
    reducer(
      documentUploadStarted,
      assistantDocumentsOperations.handleDocumentUploadStarted
    ),
    reducer(
      documentUploadSucceeded,
      assistantDocumentsOperations.handleDocumentUploadSucceeded
    ),
    reducer(
      documentUploadFailed,
      assistantDocumentsOperations.handleDocumentUploadFailed
    ),
    reducer(
      sendMessageWithHistory,
      assistantDocumentsOperations.handleClearSelectedDocuments
    ),
    reducer(
      openFullscreenChatAndSend,
      assistantDocumentsOperations.handleClearSelectedDocuments
    ),
    reducer(
      initializeNewChat,
      assistantDocumentsOperations.handleClearSelectedDocuments
    ),
    reducer(
      historicChatLoaded,
      assistantDocumentsOperations.handleClearSelectedDocuments
    ),
    reducer(setWebSearchEnabled, setStateProperty('webSearchEnabled')),
    reducer(initializeNewChat, updateState({ webSearchEnabled: false })),
    reducer(
      historicChatLoaded,
      assistantDocumentsOperations.handleWebSearchFromSession
    ),
  ]
);
